<template>
	<div class="count-down">
		<div class="container">
			<div class="card">
				<div class="box">
					<div class="percent">
						<svg :style="svgStyle">
							<!-- 外接圆  -->
							<circle v-bind="outerAttrs"></circle>
							<!-- 内接圆  -->
							<circle v-bind="innerAttrs"></circle>
						</svg>
						<div v-if="theSchond > 0" class="percent-text">{{theSchond}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import animationMixin from './animation-mixin'
export default {
	mixins: [animationMixin],
	props: {
		second: {
			type: Number,
			default: 30
		},
		radius: {
			type: Number,
			default: 70
		}
	},
	data () {
		return {
			theSchond: 0,
			firstRun: true,
			timer: null
		};
	},
	computed: {
		// 周长 
		perimeter () {
			return Math.PI * 2 * this.radius
		},
		// 内接圆属性
		innerAttrs () {
			return {
				cx: this.radius,
				cy: this.radius,
				r: this.radius,
				style: {
					"stroke-dasharray": this.perimeter,
					"stroke-dashoffset": this.perimeter - (this.perimeter * this.theSchond) / this.second
				}
			}
		},
		// 外接圆属性
		outerAttrs () {
			return {
				cx: this.radius,
				cy: this.radius,
				r: this.radius,
			}
		},
		svgStyle () {
			return {
				width: this.radius * 2 + 10,
				height: this.radius * 2 + 10,
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.count-down {
	.percent {
		position: relative;
		&-text {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			color: #26c68a;
			font-size: 50px;
			line-height: 1;
			font-weight: bold;
			transition: all 0.5s linear;
		}
		svg {
			margin: 0 auto;
			position: relative;
			display: flex;

			circle {
				width: 100%;
				height: 100%;
				fill: none;
				stroke: #fff;
				stroke-width: 10;
				stroke-linecap: round;
				transform: translate(5px, 5px);
				&:last-child {
					stroke: #21cf90;
					transition: all 0.5s linear;
					position: absolute;
					transform: translate(5px, -5px) rotate(-90deg);
					transform-origin: center center;
				}
			}
		}
	}
}
</style>
